import { SoldScheduleEntry } from '../../../clients/quipli-service/availability/availability';
import './schedule-tooltip.scss';

export const SoldTooltip = ({ soldScheduleEntry }: { soldScheduleEntry: SoldScheduleEntry }) => {
  return (
    <div className="sold-tooltip">
      <div>
        <span className="tooltip-label">Sold</span>
      </div>
      <div>
        <span className="tooltip-label">Date:</span> {soldScheduleEntry.from.toFormat('D t')}
      </div>
    </div>
  );
};
